export default "__VITE_ASSET__Drdb3aOm__"